import React from 'react';
import { createRoot } from 'react-dom/client';
import './tailwind.css';
import SightlineWebsite from './SightlineWebsite';

const container = document.getElementById('root');

createRoot(container).render(
  <React.StrictMode>
    <SightlineWebsite />
  </React.StrictMode>
);
